import React from 'react';
import { useTranslation } from 'react-i18next';

const Accommodation = () => {
    const { t } = useTranslation();

    return (
        <section id="accommodation">
            <h2>{t('where_to_stay')}</h2>
            <div className="hotel-list">
                <div className="hotel featured">
                    <div className="featured-badge">{t('recommended')}</div>
                    <img src="/images/hotels/cetina.jpg" alt={t('hotel_2_name')} className="hotel-image" />
                    <h3>{t('hotel_2_name')}</h3>
                    <p className="description">{t('hotel_2_description')}</p>
                    <div className="hotel-details">
                        <p><strong>{t('website')}:</strong> <a href={t('hotel_2_website')} target="_blank" rel="noopener noreferrer">{t('website')}</a></p>
                        <p><strong>{t('phone')}:</strong> <a href={`tel:${t('hotel_2_phone')}`}>{t('hotel_2_phone')}</a></p>
                        <p><strong>{t('email')}:</strong> <a href={`mailto:${t('hotel_2_email')}`}>{t('email')}</a></p>
                        <div className="discount-container">
                            <strong>{t('discount_code')}:</strong> <span className="discount-badge">{t('hotel_2_discount')}</span>
                        </div>
                    </div>
                </div>
                <div className="hotel">
                    <img src="/images/hotels/subup.png" alt={t('hotel_1_name')} className="hotel-image" />
                    <h3>{t('hotel_1_name')}</h3>
                    <p className="description">{t('hotel_1_description')}</p>
                    <div className="hotel-details">
                        <p><strong>{t('website_hotel')}:</strong> <a href={t('hotel_1_website_hotel')} target="_blank" rel="noopener noreferrer">{t('website')}</a></p>
                        <p><strong>{t('website_apartments')}:</strong> <a href={t('hotel_1_website_apartments')} target="_blank" rel="noopener noreferrer">{t('website')}</a></p>
                        <p><strong>{t('phone')}:</strong> <a href={`tel:${t('hotel_1_phone')}`}>{t('hotel_1_phone')}</a></p>
                        <p><strong>{t('whatsapp')}:</strong> <a href={`https://wa.me/${t('hotel_1_whatsapp').replace(/\s+/g, '').replace('+', '')}`} target="_blank" rel="noopener noreferrer">{t('whatsapp')}</a></p>
                        <p><strong>{t('email')}:</strong> <a href={`mailto:${t('hotel_1_email')}`}>{t('email')}</a></p>
                    </div>
                </div>
                <div className="hotel">
                    <img src="/images/hotels/mariaguerrero.png" alt={t('hotel_3_name')} className="hotel-image" />
                    <h3>{t('hotel_3_name')}</h3>
                    <p className="description">{t('hotel_3_description')}</p>
                    <div className="hotel-details">
                        <p><strong>{t('website')}:</strong> <a href={t('hotel_3_website')} target="_blank" rel="noopener noreferrer">{t('website')}</a></p>
                        <p>
                            <strong>{t('phone')}:</strong>
                            <span className="multiline-value">
                                {t('hotel_3_phone').split('/').map((phone, index) => (
                                    <a key={index} href={`tel:${phone.trim()}`}>{phone.trim()}</a>
                                ))}
                            </span>
                        </p>
                        <p><strong>{t('email')}:</strong> <a href={`mailto:${t('hotel_3_email')}`}>{t('email')}</a></p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Accommodation;
